import React, { useState } from 'react';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';
import { useApp } from '../contexts/AppContext';

export default function AcceptInvitation() {
  const [params] = useSearchParams();
  const token = params.get('token');
  const { api } = useApp();
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirm) { setError('Passwords do not match'); return; }
    if (password.length < 8) { setError('Password must be at least 8 characters'); return; }
    setLoading(true); setError('');
    try {
      await api('post', '/auth/accept-invitation', { token, name, password });
      setDone(true);
    } catch (err) {
      setError(err.response?.data?.message || 'Something went wrong');
    } finally { setLoading(false); }
  };

  if (!token) return <div className="container py-5 text-center"><h3>Invalid invitation link.</h3><Link to="/">Go home</Link></div>;

  return (
    <div className="summer-bg" style={{ minHeight: '100vh', display: 'flex', alignItems: 'center' }}>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-6">
            <div className="text-center mb-4">
              <img src="/logo.png" alt="logo" style={{ height: 70 }} />
              <h3 style={{ fontWeight: 900, marginTop: '1rem' }}>👩‍🏫 Teacher Account Setup</h3>
              <p style={{ color: 'var(--muted)', fontWeight: 600 }}>Create your Ryukyu GLOCAL teacher account</p>
            </div>
            <div className="card-summer p-4">
              {done ? (
                <div className="text-center">
                  <div style={{ fontSize: '4rem' }}>✅</div>
                  <h4 style={{ fontWeight: 800, marginBottom: '1rem' }}>Account Created!</h4>
                  <p style={{ color: 'var(--muted)', fontWeight: 600, marginBottom: '1.5rem' }}>You can now log in with your email and password.</p>
                  <Link to="/login" className="btn-summer text-decoration-none">Go to Login →</Link>
                </div>
              ) : (
                <form onSubmit={handleSubmit}>
                  <div className="mb-3">
                    <label style={{ fontWeight: 700, fontSize: '0.85rem', color: 'var(--muted)', display: 'block', marginBottom: '0.4rem' }}>Your Name</label>
                    <input type="text" className="input-summer" value={name} onChange={e => setName(e.target.value)} required />
                  </div>
                  <div className="mb-3">
                    <label style={{ fontWeight: 700, fontSize: '0.85rem', color: 'var(--muted)', display: 'block', marginBottom: '0.4rem' }}>Password</label>
                    <input type="password" className="input-summer" value={password} onChange={e => setPassword(e.target.value)} required />
                  </div>
                  <div className="mb-4">
                    <label style={{ fontWeight: 700, fontSize: '0.85rem', color: 'var(--muted)', display: 'block', marginBottom: '0.4rem' }}>Confirm Password</label>
                    <input type="password" className="input-summer" value={confirm} onChange={e => setConfirm(e.target.value)} required />
                  </div>
                  {error && <div className="alert alert-danger mb-3" style={{ borderRadius: 12, fontWeight: 600 }}>{error}</div>}
                  <button type="submit" className="btn-summer w-100" disabled={loading}>
                    {loading ? '⏳ ...' : '✅ Create Account'}
                  </button>
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
